import { Suspense, lazy, memo } from 'react';
import { useLocation } from 'react-router-dom';

import { Card, Tabs } from 'antd';

import RotationTable from '../../../components/Grazing/RotationTable';
import LoadingBar from '../../../components/LoadingBar';

const Alerts = lazy(() => import('../../../components/Alerts'));

const DEFAULT_TAB = 'rotations';

function GeofenceHistory({ geofenceId, geofences, fetchData, handleSearchChange }) {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const tab = queryParams.get('tab');
  const items = [
    {
      key: 'rotations',
      label: 'Grazing Rotations',
      children: (
        <Suspense fallback={<LoadingBar />}>
          <RotationTable geofences={geofences} fetchData={fetchData} handleSearchChange={handleSearchChange} />
        </Suspense>
      )
    },
    {
      key: 'notifications',
      label: 'Notifications',
      children: (
        <Suspense fallback={<LoadingBar />}>
          <Alerts type="full" query={{ geofence_ids: [geofenceId] }} />
        </Suspense>
      )
    }
  ];

  return (
    <Card>
      <Tabs defaultActiveKey={tab || DEFAULT_TAB} items={items} />
    </Card>
  );
}

export default memo(GeofenceHistory);
